export const getFormattedlocalDate = (dateTimeString) => {
  const dateObject = new Date(dateTimeString)
  const year = dateObject.getFullYear()
  const months = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december']
  const month = months[dateObject.getMonth()]
  const date = dateObject.getDate()
  return `${year}. ${month} ${date}.`
}